module.exports = __webpack_public_path__ + "img/DuoCoat.16fdc5a0.jpg";